<template>
  <div class="places__list">
    <div class="places__list-nav">
      <a :class="['btn btn-text-gradient-dark', (selectedType == 'restaurant' ? 'btn-text-gradient--active' : '')]" @click="selectedType = 'restaurant'">
        {{ KriensTourismus.languageKeys['restaurant'] }}
      </a>
      <a :class="['btn btn-text-gradient-dark', (selectedType == 'hotel' ? 'btn-text-gradient--active' : '')]" @click="selectedType = 'hotel'">
        {{ KriensTourismus.languageKeys['hotel'] }}</a>
      <a :class="['btn btn-text-gradient-dark', (selectedType == 'shopping' ? 'btn-text-gradient--active' : '')]" @click="selectedType = 'shopping'">
        {{ KriensTourismus.languageKeys['shopping'] }}
      </a>
      <a :class="['btn btn-text-gradient-dark', (selectedType == 'culture' ? 'btn-text-gradient--active' : '')]" @click="selectedType = 'culture'">
        {{ KriensTourismus.languageKeys['culture'] }}
      </a>
    </div>
    <div v-for="place in filteredPlaces"
         :key="place.data.name[0].text"
         class="places__list-item"
         @click="$emit('focusPlace', place)"
    >
      <h2>{{ place.data.name[0].text }}</h2>
      <p v-if="place.data.description[0]" class="lead-text">{{ place.data.description[0].text }}</p>
      <prismic-link v-if="place.data.link.url"
                    class="btn btn-read-more"
                    :field="place.data.link" target="_blank">
          {{ KriensTourismus.languageKeys['to-website'] }}
        </prismic-link>
    </div>
  </div>
</template>

<script>
import EventBus from '../../EventBus'

export default {
  name: 'PlacesList',
  data () {
    return {
      allPlaces: [],
      selectedType: 'restaurant'
    }
  },
  methods: {
    async getContent(language) {
      let document = await this.$prismic.client.query(this.$prismic.Predicates.at('document.type', 'place'), {lang: language})
      if (document) {
        this.allPlaces = document.results
        this.$emit('listChanged', this.allPlaces)
      }
    },
    checkSelectedType() {
      if (window.location.hash.includes('restaurant')) this.selectedType = 'restaurant'
      if (window.location.hash.includes('hotel')) this.selectedType = 'hotel'
      if (window.location.hash.includes('shopping')) this.selectedType = 'shopping'
      if (window.location.hash.includes('culture')) this.selectedType = 'culture'
    }
  },
  computed: {
    filteredPlaces () {
      return this.allPlaces.filter(place => place.data.type == this.selectedType)
    }
  },
  watch: {
    selectedType (newType) {
      this.$emit('typeChanged', newType)
    },
    $route (){
      this.checkSelectedType()
    }
  },
  async created() {
    await this.getContent(window.KriensTourismus.language)

    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  },
  mounted () {
    this.checkSelectedType()
  }
}
</script>